import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2de2b3fa&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
import style0 from "./Index.vue?vue&type=style&index=0&id=2de2b3fa&prod&lang=scss"
import style1 from "./Index.vue?vue&type=style&index=1&id=2de2b3fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de2b3fa",
  null
  
)

export default component.exports